/* eslint-disable react-hooks/exhaustive-deps */
import React from "react";
import { useEffect } from "react";
import { Button, Loader, View } from '@aws-amplify/ui-react';
import '@aws-amplify/ui-react/styles.css';
import { FaceLivenessDetector } from '@aws-amplify/ui-react-liveness';

function FaceLiveness({faceLivenessAnalysis, tryAgain, eventId, token}) {
    const [loading, setLoading] = React.useState(true);
    const [sessionId, setSessionId] = React.useState(null);

    const url = `https://dnche9w2ykvsb.cloudfront.net/api/event/${eventId}/liveness`;

   /*
   * Create the Face Liveness Session
   */
   const fetchCreateLiveness = (async () => {
      console.log(`create ${eventId}`);
      const body = {
        token
      };
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': 'UWrQYxSWml2KDnh01WzRv5zq55jLsBPW85jgeZnV'
        },
        body: JSON.stringify(body),
      });
      const data = await response.json();
      console.log(`sessionId: ${data.sessionId}`);
      setSessionId(data.sessionId)
      setLoading(false);

    });

    useEffect(() => {
        fetchCreateLiveness();
    },[])

   /*
   * Get the Face Liveness Session Result
   */
    const handleAnalysisComplete = async () => {
      console.log(`complete ${eventId}`);
        const response = await fetch(`${url}/${sessionId}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'x-api-key': 'UWrQYxSWml2KDnh01WzRv5zq55jLsBPW85jgeZnV'
          },
        });
        const data = await response.json();
        faceLivenessAnalysis(data)
    };

    const handleError = async (livenessError) => {
      console.log(livenessError);

      const body = {
        sessionId,
        data: livenessError.error.message
      };
      await fetch(`https://dnche9w2ykvsb.cloudfront.net/api/event/${eventId}/livenesserror`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-api-key': 'UWrQYxSWml2KDnh01WzRv5zq55jLsBPW85jgeZnV'
        },
        body: JSON.stringify(body),
      });
    }

    const handleClick = async () => {
      setSessionId(null);
      setLoading(true);
      tryAgain();
    }

    return (
        <>
            {loading ? (
                <Loader />
            ) : (
                <FaceLivenessDetector
                    sessionId={sessionId}
                    region="us-east-1"
                    onAnalysisComplete={handleAnalysisComplete}
                    onError={(livenessError) => handleError(livenessError)}
                    components={{
                      ErrorView: ({ children }) => {
                        return (
                          <View flex="1" backgroundColor="white" className="amplify-flex amplify-liveness-overlay amplify-liveness-overlay-opaque">
                            <div className="amplify-liveness-toast amplify-liveness-toast--default amplify-liveness-toast--medium">
                              <div className="amplify-flex amplify-liveness-toast__container">
                                {children}
                                <div className="amplify-flex">
                                  <Button className="amplify-button amplify-field-group__control amplify-button--primary" data-fullwidth="false" data-variation="primary" type="button" onClick={handleClick}>Try again</Button>
                                </div>
                              </div>
                            </div>
                          </View>
                        );
                      },
                    }}                
                />
            )}
        </>
    );
}

export default FaceLiveness;
